import React from "react";
import { useReportContext } from "./ReportContext";
import { IReportElement, IReportSlide } from "./ReprortContextTypes";
import slideContext, { useSlideContext } from "./SlideContext";
import { createUUID } from "./utils";

const SlideContextProvider = slideContext.Provider;

const SlideTableRow = (props: React.PropsWithChildren<{}>) => {
  const parentSlide = useSlideContext();
  const element = React.useRef<IReportElement>({
    isReady: false,
    type: "row",
    text: "",
    children: [],
  });
  const currentSlide = React.useRef<IReportSlide>({
    uuid: `${createUUID()}`,
    isReady: false,
    elements: [],
    addElement: (newElement) => {
      currentSlide.current.elements?.push(newElement);
      element.current?.children?.push(newElement);
    },
    onElementReady: (newElement) => {
      newElement.isReady = true;
      currentSlide.current?.checkReadiness?.();
    },
    checkReadiness: () => {
      const slide = currentSlide.current;
      if (slide) {
        if (!slide.isReady && slide.hasRenderedAtLeastOnce) {
          const readyCnt =
            slide.elements?.filter((el) => el.isReady).length || 0;
          const allCnt = slide.elements?.length || 0;
          if (readyCnt === allCnt) {
            slide.isReady = true;
            /*
                Table row is ready
            */
            console.log("slide table row ready ", slide);

            if (parentSlide) {
              parentSlide?.onElementReady?.(element.current);
            }

            /// if(parentSlide.addElement())
          }
        }
      }
    },
  });

  React.useEffect(() => {
    if (parentSlide) {
      parentSlide?.addElement?.(element.current);
    }
    if (currentSlide && currentSlide.current) {
      currentSlide.current.hasRenderedAtLeastOnce = true;
      currentSlide.current.checkReadiness?.();
    }
  }, []);
  return (
    <div>
      <h1>Tablerow</h1>
      <SlideContextProvider value={currentSlide.current}>
        {props.children}
      </SlideContextProvider>
    </div>
  );
};

export default SlideTableRow;
